import ClearIcon from '@/assets/icons/clear.svg?react';
import { ComponentPropsWithoutRef, FC, KeyboardEventHandler, MouseEventHandler, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

type ClearButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'onClick' | 'onKeyDown'> & { onClick?: VoidFunction };

export const ClearButton: FC<ClearButtonProps> = ({ className, onClick, ...props }) => {
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      e.stopPropagation();
      onClick?.();
    },
    [onClick]
  );

  const handleKeyDown = useCallback<KeyboardEventHandler<HTMLButtonElement>>(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
        onClick?.();
      }
    },
    [onClick]
  );

  return (
    <button
      {...props}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={twMerge(
        'absolute top-1/2 -translate-y-1/2 right-4 translate-1/2 hover:text-black-100 hover:scale-125 motion-safe:transition-all motion-safe:duration-300 motion-reduce:transition-none focus-visible:outline-0 focus-visible:ring-2 ring-blue-600 rounded',
        className
      )}
    >
      <ClearIcon />
    </button>
  );
};
